import { getCookie, setCookie } from "~/foundation/Utils/cookie";

export type ChatHistoryCookie = {
    [articleId: string]: string[]; // Array of chatlogIds
};

export function getChatHistoryCookie(): ChatHistoryCookie {
	const cookieValue = getCookie("chatHistory");
	if (!cookieValue) return {};
	try {
		const parsed = JSON.parse(cookieValue) as ChatHistoryCookie;
		return parsed;
	} catch {
		return {};
	}
}

export function updateChatHistoryCookie(articleId: string, chatlogId: string) {
	const currentCookie = getChatHistoryCookie();
	if (!currentCookie[articleId]) {
		currentCookie[articleId] = [];
	}
	if (!currentCookie[articleId].includes(chatlogId)) {
		currentCookie[articleId].push(chatlogId);
		setCookie("chatHistory", JSON.stringify(currentCookie));
	}
}